export const PERMISSIONS = {
  users: {
    view: "Usuários",
  },
  settings: {
    empresa: {
      view: "configuracoes.empresa.view",
    },
    checklistTasks: {
      view: "configuracoes.tarefas_checklist.view",
    },
    taskRegistration: {
      view: "configuracoes.cadastro_tarefas.view",
    },
    systemVariables: {
      view: "configuracoes.variaveis.view",
    },
    monthlyModule: {
      view: "configuracoes.modulo_mensalidades.view",
    },
    sporadicDocs: {
      view: "configuracoes.docs_esporadicos.view",
    },
    integracoes: {
      view: "configuracoes.integracoes.view",
    },
    permissoes: {
      view: "configuracoes.permissoes.view",
    },
    societarioStages: {
      view: "configuracoes.etapas_societario.view",
    },
  },
  customers: {
    view: "Clientes",
    create: "customers.create",
    edit: "customers.edit",
    delete: "customers.delete",
  },
  checklist: {
    view: "checklist",
    review: "checklist.review",
    columns: {
      legalization: "checklist.columns.legalization",
      administrative: "checklist.columns.administrative",
      accounting: "checklist.columns.accounting",
      fiscal: "checklist.columns.fiscal",
      personal: "checklist.columns.personal",
      cs: "checklist.columns.cs",
    },
  },
  calendarTasks: {
    view: "Tarefas",
    create: "Cadastro de Tarefas",
  },
  conference: {
    view: "tarefas.conferencia.view",
  },
  extratoBancario: {
    view: "contabil.extrato_bancario.view",
  },
  documents: {
    view: "documents",
  },
  corporate: {
    view: "Abertura e Encerramento",
    create: "societario.create",
    createBillsToPay: "Abertura e Encerramento (Criar contas a pagar)",
    financial: {
      view: "societario.financial.view",
    },
  },
  certificates: {
    view: "Certificados",
  },
  procurations: {
    view: "procurations.view",
  },
  conventions: {
    view: "Convenções",
  },
  financial: {
    monthlyPayments: {
      view: "financeiro.mensalidades",
      edit: "financeiro.mensalidades.edit",
      delete: "financeiro.mensalidades.delete",
    },
    bankReconciliation: {
      view: "financeiro.conciliacao.view",
      edit: "financeiro.conciliacao.edit",
    },
    bancos: {
      view: "financeiro.bancos.view",
      edit: "financeiro.bancos.edit",
    },
    contasPagar: {
      view: "financeiro.contas_pagar.view",
      edit: "financeiro.contas_pagar.edit",
    },
    contasReceber: {
      view: "financeiro.contas_receber.view",
      edit: "financeiro.contas_receber.edit",
    },
    extrato: {
      view: "financeiro.extrato.view",
    },
  },
  extraServices: {
    view: "se.view",
    edit: "se.edit",
    delete: "se.delete"
  },
  refunds: {
    view: "refunds",
    edit: "refunds.edit",
    delete: "refunds.delete",
  },
  leads: {
    view: "leads",
  },
  leadsRT: {
    view: "leadsRT",
  },
  prospecting: {
    view: "prospecting",
  },
  irpf: {
    view: "IRPF",
    summary: {
      view: "IRPF.summary",
    },
    malhaFina: {
      view: "IRPF.malha_fina",
    },
    dividasTributarias: {
      view: "dividas_tributarias.view",
    },
  },
  links: {
    view: "links.view",
  },
  documentsDeadline: {
    view: "documents_deadline.view",
  },
  honoraries: {
    view: "honoraries.view",
  },
  sentEmails: {
    view: "sent_emails.view",
  },
  feedbacks: {
    view: "feedbacks.view",
  },
  marketing: {
    campaigns: {
      view: "marketing.campanhas.view",
      edit: "marketing.campanhas.edit",
      send: "marketing.campanhas.send",
    },
  },
  boards: {
    view: "boards.view",
  },
  solicitations: {
    view: "solicitations.view",
  },
  referralProgram: {
    view: "referral_program.view",
  },
  plugins: {
    view: "plugins.view",
  },
  knowledgeBase: {
    view: "knowledge_base.view",
  },
  reports:{
    defaulters: 'reports.defaulters.view',
    partners: 'reports.partners.view',
  },
  graphs: {
    monthlyPayments: {
      view: "monthly_payments_graph",
    },
    customersCount: {
      view: "customers_count_graph",
    },
    dashTasks: {
      view: "dash_tasks_summary",
    },
    extraPayments: {
      view: "extra_payments_graph",
    },
    calendarTasks: {
      view: "calendar_tasks_graph",
    },
    certificates: {
      view: "certificates_summary",
    },
    leads: {
      view: "leads_graph",
    },
    customersByType: {
      view: "customers_by_type_graph",
    },
  },
  socialSelling: {
    view: "socialSelling.view",
  },
};
